const genders = [
    { "name": "Female", "id":  "female" },
    { "name": "Male", "id":  "male" }
];

export default genders;